import React, { useContext } from 'react';
import cn from 'classnames';
import { string, bool, object, shape } from 'prop-types';
import VerticalNav from '../VerticalNav';
import Avatar from '../Avatar';
import PopupContext from '../../context/PopupContext';
import Link from '../../atoms/Link';
import PopupBackdrop from '../../atoms/PopupBackdrop';
/**
 * SidebarNav component.
 */

var SidebarNav = function SidebarNav(_ref) {
  var className = _ref.className,
      accountNavOptions = _ref.accountNavOptions,
      profileDetails = _ref.profileDetails,
      left = _ref.left;

  var _useContext = useContext(PopupContext),
      activePopup = _useContext.activePopup,
      popupKeys = _useContext.popupKeys;

  var _ref2 = profileDetails || {},
      avatar = _ref2.avatar;

  if (avatar) {
    avatar.sizes = ['(min-width: 992px) 100px', '60px'];
    avatar.srcSetBreakpoints = [100, 250, 300, 60, 150, 180];
  }

  return /*#__PURE__*/React.createElement("aside", {
    className: cn('sidebar-nav', className, activePopup === popupKeys.account && 'sidebar-nav--open')
  }, /*#__PURE__*/React.createElement("div", {
    className: 'sidebar-nav__container' + (left ? " sidebar-nav__container--left" : "")
  }, /*#__PURE__*/React.createElement("div", {
    className: "sidebar-nav__profile"
  }, /*#__PURE__*/React.createElement("div", {
    className: "sidebar-nav__profile-image-container"
  }, /*#__PURE__*/React.createElement(Link, {
    href: accountNavOptions.settingsUrl,
    aria: {
      label: 'My settings'
    }
  }, /*#__PURE__*/React.createElement(Avatar, {
    image: avatar
  }))), /*#__PURE__*/React.createElement("div", {
    className: "sidebar-nav__profile-name"
  }, profileDetails === null || profileDetails === void 0 ? void 0 : profileDetails.nickname)), /*#__PURE__*/React.createElement(VerticalNav, {
    ariaLabel: "Side navigation",
    domId: "".concat(popupKeys.account, "-popup"),
    menuItems: accountNavOptions === null || accountNavOptions === void 0 ? void 0 : accountNavOptions.menuItems,
    showSubmenu: true
  })), /*#__PURE__*/React.createElement(PopupBackdrop, {
    active: activePopup === popupKeys.account
  }));
};

SidebarNav.defaultProps = {
  className: null,
  accountNavOptions: {},
  profileDetails: {},
  left: false
};
SidebarNav.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Additional class names to add to the component root. */
  className: string,

  /** Menu items for the navigation */
  accountNavOptions: shape({
    menuItems: VerticalNav.propTypes.menuItems,
    settingsUrl: string
  }),

  /** Array of menu items */
  profileDetails: object,

  /** Sets sidebar right or left */
  left: bool
} : {};
export default SidebarNav;